<template>
  <section class="section contact">
    <div class="container contact-grid">
      <div>
        <h1>Contact</h1>
        <p class="lead">
          Nous répondons sous 24h ouvrées.
        </p>
        <div class="contact-details">
          <div>
            <p class="label">Adresse</p>
            <p>45 rue Malesherbes, 69006 Lyon</p>
          </div>
          <div>
            <p class="label">E-mail</p>
            <p>bergierassurances@outlook.fr</p>
          </div>
          <div>
            <p class="label">Horaires</p>
            <p>Lun - Ven : 9h00 - 18h30</p>
          </div>
        </div>
      </div>
      <form class="contact-card" @submit.prevent="sendMail">
        <label>
          Nom & prénom
          <input v-model="form.name" type="text" placeholder="Votre nom" />
        </label>
        <label>
          E-mail
          <input v-model="form.email" type="email" placeholder="nom@exemple.fr" />
        </label>
        <label>
          Sujet
          <input v-model="form.subject" type="text" placeholder="Assurance habitation, santé..." />
        </label>
        <label>
          Message
          <textarea v-model="form.message" rows="4" placeholder="Décrivez votre besoin"></textarea>
        </label>
        <button type="submit" class="button primary full">Envoyer la demande</button>
        <p class="privacy">Vos informations restent strictement confidentielles.</p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    };
  },
  methods: {
    sendMail() {
      const { name, email, subject, message } = this.form;
      const mailSubject = subject || 'Demande de contact';
      const body = [
        `Nom: ${name}`,
        `Email: ${email}`,
        '',
        message
      ]
        .filter(Boolean)
        .join('\n');

      const mailto = `mailto:bergierassurances@outlook.fr?subject=${encodeURIComponent(
        mailSubject
      )}&body=${encodeURIComponent(body)}`;

      window.location.href = mailto;
    }
  }
};
</script>
